// base
import React, { Suspense, useEffect, useState } from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';

// styles
import './assets/scss/index.scss';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/effect-fade';
import 'react-resizable/css/styles.css';

// routes
import { routes } from 'routes';
import { PrivateRoute } from 'routes/PrivateRoute';

// components
import { AuthorizedResult, NotFoundResult, PageLoader } from 'components';

// modules
import { LoadingAtom } from 'modules';

// hooks
import { useParentData, useUser } from 'hooks';

// libraries
import './libs/web-ifc-api';
import styled from 'styled-components';
import { useRecoilValue } from 'recoil';

const StyledApp = styled.div`
  height: 100vh;
  position: relative;
`;

const App = () => {
  const [accountType, setAccountType] = useState(null);

  const loading = useRecoilValue(LoadingAtom);
  const location = useLocation();

  useParentData();
  const { userInfo } = useUser();

  const isPermission = (userInfo) => {
    if (!userInfo || !userInfo.role) return false;

    const role = userInfo.role;

    const arr = ['ADMIN', 'USER', 'PARTNER'];
    const checkArr = arr.every((item) => item === role);

    return !checkArr;
  };

  useEffect(() => {
    if (!userInfo || !userInfo.role) return;

    const role = userInfo.role || null;

    setAccountType(role);
  }, [userInfo]);

  return (
    <StyledApp>
      {loading && <PageLoader />}

      <Suspense fallback={<PageLoader />}>
        <Switch location={location}>
          {!accountType &&
            routes.public.map((item) => (
              <Route key={item.path} path={item.path} component={item.component} />
            ))}

          {accountType &&
            routes[accountType]?.map((item) => (
              <PrivateRoute
                key={item.path}
                path={item.path}
                fallback={AuthorizedResult}
                isPermission={isPermission}
                component={item.component}
                exact
              />
            ))}
          <Route path="*" component={NotFoundResult} />
        </Switch>
      </Suspense>
    </StyledApp>
  );
};

export default App;
